import { render, staticRenderFns } from "./AnalysisNavigationTabs.vue?vue&type=template&id=518d961e"
import script from "./AnalysisNavigationTabs.vue?vue&type=script&lang=ts"
export * from "./AnalysisNavigationTabs.vue?vue&type=script&lang=ts"
import style0 from "./AnalysisNavigationTabs.vue?vue&type=style&index=0&id=518d961e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports